<template>
  <div class="page-wrap PetAdminFaultList-page" ref="container">
		<Search :label="searchLabel" :dateFilter="false" @search="search" ref='search'></Search>
		<List title="故障信息列表" :refresh="true" :label="label" apiName="petDeviceFaultList" ref="list"></List>
		
		<Popup v-model="showPopup" closeable round @closed="popupClosed">
			<div class="info-content">
				<textarea
				  placeholder="填写故障描述"
				  v-model="info.content"
				></textarea>
				<div class="btn" @click="applyRepair"> 报修 </div>
			</div>
		</Popup>
		
  </div>
</template>
<script>
import PetApi from "../../api/petAdmin";
import Search from "@components/Search";
import List from "@components/List";
import {Popup} from 'vant';

export default {
  name: "PetAdminFaultList",
  components: {
		Search,
		List,
		Popup
  },
  props: {},
  data: function() {
    return {
      filter: {
      },
			searchLabel : [
				{field : 'machineCode', title : '设备编码'},
			],
			label : [
				{field : 'deviceSn', title : '设备编码'},
				{field : 'address', title : '设备地址'},
				{field : 'name', title : '设备名称'},
				{field : 'createTime', title : '发生时间'},
				{field : 'message', title : '故障类型', type : "status"},
				{field : 'btn', title : '报修', type : 'btn', btnStyle: {background: '#F5A100',color: '#FFFFFF'}, click: this.repair, showFiels : ['isRepair', 0]},
				{field : 'btn', title : '已报修', type : 'btn', btnStyle: {background: '#F5A100',color: '#FFFFFF'}, click: this.repair, showFiels : ['isRepair', 1]}
			],
			showPopup : false,
			info : {
				id : '',
				deviceSn : '',
				content : '',
			},
    };
  },
  watch: {
    $route(n) {
      if (n.name === 'PetAdminFaultList') {
    		let prevPage = this.$prevRoute();
    		if (prevPage && prevPage.name == "PetAdmin") {
    			this.$refs.search.reSet();
    			this.filter = {};
    			this.search(this.filter);
    		}
      }
    }
  },
  mounted: function() {
  },
  computed: {},
  methods: {
		search(filter) {
			this.filter = filter;
			this.$refs.list.reload(filter);
		},
		repair(item) {
			if (item.isRepair == 1) return this.$dialog.message('已报修');
			this.showPopup = true;
			this.info = { id : item.id, deviceSn: item.deviceSn, content : item.message}
		},
		popupClosed() {
			this.info = {
				id : '',
				deviceSn : '',
				content : '',
			}
		},
		applyRepair() {
			if (!this.info.content) return this.$dialog.message('请填写故障描述');
			let that = this;
			PetApi.petApplyFault(that.info).then(
			  res => {
					that.$dialog.message(res.msg);
					that.showPopup = false;
					that.search(that.filter);
			  },
			  error => {
			    that.$dialog.message(error.msg);
			  }
			);
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}

.PetAdminFaultList-page {
	&.page-wrap {
		padding: 0.3rem;
	}
	.info-content {
		width : 6.7rem;
		text-align : center;
		margin-top: 1.5rem;
		
		textarea {
			border: 0.01rem solid #c8c9cc;
			border-radius: 0.1rem;
			width: 90%;
			padding: 0.2rem;
			height: 2rem;
		}
		
		.btn {
			margin:0.4rem auto;
			width:2rem;
			font-weight: 400;
			font-size: 0.28rem;
			text-align: center;
			padding: 0.12rem 0.26rem;
			border-radius: 0.08rem;
			background: #F5A100;
			color:#fff;
		}
	}
}

</style>
